import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalDirective } from 'angular-bootstrap-md';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Clothes } from 'src/app/models/Clothes';
import { NocSizes } from 'src/app/models/NocSizes';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ClothesService } from 'src/app/services/clothes.service';
import { FileService } from 'src/app/services/file.service';
import { CONSTANTES, getToken } from 'src/app/shared/global';
import * as XLSX from 'xlsx';

declare var jQuery: any;

@Component({
  selector: 'app-stock',
  templateUrl: './stock.component.html',
  styleUrls: ['./stock.component.scss']
})
export class StockComponent implements OnInit {
  nocsData: any[] = [];
  listNocSizes: NocSizes[] = [];
  titulos: String[] = ['TALLA', 'NOC', 'CODIGO INTERNO', 'NPC','STOCK','UMBRAL','CANTIDAD MAXIMA'];
  clothes: Clothes[] = [];
  clothesStockOut: String[] = [];
  numberClothesStockOut: number;
  nocSizes : NocSizes[] = [];
  item: Clothes= new Clothes();
  form: FormGroup;
  nocSizeData: NocSizes = new NocSizes();
  selectEdit: String;
  selectStock : number = null;
  selectThreshold : number = null;
  selectMaxAmount :number = null;
  indexSelect: number = 0;
  action: String;
  breakThreshold :boolean = null;
  @ViewChild('stockModal') stockModal: ModalDirective;
  @ViewChild('stockFileModal') stockFileModal: ModalDirective;
  headingWindows: any;
  user: string;

  constructor(private spinner: NgxSpinnerService, private toastr: ToastrService, 
    private clothesService: ClothesService, private authService: AuthenticationService, 
    private router: Router, private fileService: FileService,) { }

  ngOnInit() {
    this.spinner.show();
    this.user = localStorage.getItem("nid");
    try{
      jQuery.getScript(CONSTANTES.menu);
    } catch(Error){
      this.router.navigate(['login']);
    }
    this.item.nocSizes = [];

    this.item.nocSizes.push(
      {
        id: null,
        npc:null,
        noc:null,
        internalCode: null,
        size:null,
        stock:null,
        sex: null,
        threshold: null,
        maxAmount: null, 
        generalStaff: null,
        job: null,
        ribbon: null,
        weapon: null
      }
    )

    this.form = new FormGroup({
      'name': new FormControl('', Validators.required),
      'size': new FormControl('', Validators.required),
      'noc': new FormControl('', Validators.required),
      'npc': new FormControl('', Validators.required),
      'threshold': new FormControl('', Validators.required),
    });

    this.clothesStock();
    
  }

  /**Obtiene las prendas con posible rotura de stock*/
  clothesStock(){
    this.clothesService.getDetailStockOut().subscribe(
      data => {
        if (getToken(data)) {
          this.clothesStockOut = data.detailStockOut;
          this.clothesStockOut.sort((a, b) => {
            if (a < b) {
              return -1;
            } else if (a > b) {
              return 1;
            } else {
              return 0;
            }
          });
          this.numberClothesStockOut = this.clothesStockOut.length;
          this.loadClothesInfo();
        }
      },
      error => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL OBTENER LAS PRENDAS CON ROTURA DE STOCK", "ERROR");
        this.loadClothesInfo();
      }  
    )
    //this.spinner.hide();
  }

  /*Cambia los nombres del articulo*/
  editNames(){
    this.clothesService.saveClothes(this.item).subscribe(
      data => {
        if (getToken(data)) {
          this.toastr.success("DATOS CORRECTAMENTE ACTUALIZADOS", "INFO");
        }
      },
      error => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL GUARDAR LOS DATOS", "ERROR");
      }  
    )
    //this.spinner.hide();
  }

  /**Carga la informacion de las prendas*/
  loadClothesInfo() {

    this.clothesService.getClothesWithoutData().subscribe(
      data => {
        if (getToken(data)) {
          this.clothes = data.clothes;
          this.clothes.sort((a, b) => {
            if (a.name < b.name) {
              return -1;
            } else if (a.name > b.name) {
              return 1;
            } else {
              return 0;
            }
          });
        }
        this.spinner.hide();
      }, error => {
        this.logOut();
      }
    );
  }
  
  /**Metodo que rellena campos al seleccionar prenda */
  async getItem() {
    let code: string = this.form.value["name"];
    this.item = await this.clothesService.getClothByCode(code).toPromise();
/*     this.clothes.forEach(element => {
      if (element.code == code) {
        return this.item = element;
      }
    }); */
  }

  /**Metodo que edita los campos de la tabla */
  edit(index: number) {
    this.action = "Editar";
    this.createData(index);
    this.indexSelect = index;
    this.stockModal.show();
  }

  /**Metodo que se encarga de crear o cargar la información en el modal para insertar o editar*/
  createData(index: number) {
    this.selectEdit = null;
    if (this.action === "Editar") {
      this.nocSizeData.size = this.item.nocSizes[index].size.toString();
      this.selectStock = this.item.nocSizes[index].stock;
      this.selectThreshold = this.item.nocSizes[index].threshold;
      this.selectMaxAmount = this.item.nocSizes[index].maxAmount;
    }
  }

  /**Metodo que se encarga de insertar registros*/
  insertData(){
    this.item.nocSizes[this.indexSelect].stock = this.selectStock;
    this.item.nocSizes[this.indexSelect].threshold = this.selectThreshold;
    this.item.nocSizes[this.indexSelect].maxAmount = this.selectMaxAmount;
      this.clothesService.saveClothes(this.item).subscribe(
        data => {
          if (getToken(data)) {
            this.stockModal.hide();
            this.toastr.success("DATOS CORRECTAMENTE ACTUALIZADOS", "INFO");
          }
        },
        error => {
          this.spinner.hide();
          this.toastr.error("HA OCURRIDO UN ERROR AL GUARDAR LOS DATOS", "ERROR");
        }  
      )
      this.spinner.hide();

  }

  /**Metodo que se encarga de cerrar y liberar la memoria del modal*/
  closeModal(){
    this.stockModal.hide();
    this.stockModal.ngOnDestroy();
  }

  logOut() {
    let infoUser = {
      userName: localStorage.getItem("nid")
    }
    this.authService.logOut(infoUser).subscribe(
      data => {
        localStorage.clear();
        this.router.navigate(['login']);
      }
    );
  }

  onFileChange(event: any, fileType: string): void {
    const target = event.target as HTMLInputElement;

    if (target.files && target.files.length) {
      const file = target.files[0];
      const reader = new FileReader();

      reader.onload = (e: any) => {
        const bstr: string = e.target.result;
        const workbook: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        if (fileType === 'nocs') {
          this.nocsData = jsonData;
        }
      };

      reader.readAsBinaryString(file);
    } else {
      if (fileType === 'nocs') {
        this.nocsData = [];
      }
    }
  }

  sendDataToBackend(fileType: string): void {
    this.spinner.show();
    let data = [];
    if(fileType === 'nocs'){
      data = this.nocsData;
    }else{
      data = [];
    }
    

    if (data.length > 0) {
      const allowedExtensions = ['xlsx', 'xls'];
      const fileInput = document.getElementById(fileType === 'nocs' ? 'nocsFile' : 'internalCodeFile') as HTMLInputElement;

      if (fileInput && fileInput.files.length) {
        const file = fileInput.files[0];
        const fileExtension = file.name.split('.').pop().toLowerCase();

        if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
          this.toastr.warning('SELECCIONE UN ARCHIVO CORRECTO (xlsx or xls).');
          return;
        }
      } else {
        this.toastr.warning('SIN ARCHIVO SELECCIONADO');
        return;
      }

      if(fileType === 'nocs'){
        this.fileService.updateStock(data, this.user).subscribe(
          data => {
            if (getToken(data)) {
              this.toastr.success("STOCK DE PRENDAS ACTUALIZADO");
            }
            if (data.errorFileBase64) {
              this.downloadTxtFile(data.errorFileBase64, 'erroresStock.txt');
            }
            this.spinner.hide();
          }, error => {
            this.toastr.error(error);
            this.logOut();
          }
        );
      }else{
        this.toastr.warning("ARCHIVO ERRONEO");
      }
    }else{
      this.toastr.warning("SIN ARCHIVO SELECCIONADO");
      this.spinner.hide();
    }
  }

  downloadTxtFile(base64Content: string, fileName: string): void {
    const decodedContent = atob(base64Content);
    const blob = new Blob([decodedContent], { type: 'text/plain' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(link.href);
  }

  openModalStockFile(){
    this.stockFileModal.show();
  }

}
